import { DOCUMENT } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EncryptService } from 'src/app/core/services';
import { ContactService } from 'src/app/features/contact';
import { DocumentsServe, Shared, TabSize } from 'src/app/utils/constants';
import { PageTab } from 'src/app/utils/enums';
import {
  downloadVCard,
  getImageBase64FromUrl,
  vCard,
} from 'src/app/utils/helpers';
import { PublicCardData, SocialNetworks } from 'src/app/utils/models';

@Component({
  selector: 'shared-left-card',
  templateUrl: './left-card.component.html',
  styleUrls: ['./left-card.component.scss'],
})
export class LeftCardComponent implements OnChanges {
  @Input() publicCardData: PublicCardData;
  @Input() socialNetworksList: SocialNetworks[];
  urlQR: string;
  cache: string;
  profileImage: string;
  sessionActive: boolean;
  userId: any;

  @Input() currentScroll: number;
  @Input() currentTab: number;
  @Input() logeado: boolean = false;
  @Output() currentTabChange: EventEmitter<number>;
  @Output() statusScroll: EventEmitter<number>;
  constructor(
    @Inject(DOCUMENT) document: any,
    private toastr: ToastrService,
    private readonly contact: ContactService,
    private readonly encrypt: EncryptService,
    private readonly user: EncryptService
  ) {
    this.publicCardData = new PublicCardData();
    this.socialNetworksList = [];
    this.urlQR = document.location.href;
    this.cache = '?nocache=' + Math.random();
    this.profileImage = '';
    this.sessionActive = this.validateSession();

    this.currentScroll = 0;
    this.currentTab = PageTab.ABOUTME;
    this.statusScroll = new EventEmitter<number>();
    this.currentTabChange = new EventEmitter<number>();
    this.userId = this.user.getSession().idUsuario;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('publicCardData' in changes) {
      if (this.publicCardData.urlFotoPerfil !== '') {
        this.profileImage =
          DocumentsServe.COVERPHOTOS +
          this.publicCardData.idTarjeta +
          '/' +
          this.publicCardData.urlFotoPerfil +
          this.cache;
      }
    }
  }

  addEventQr(): void {
    const vara = document.querySelectorAll('#qr img')[0];
    vara.addEventListener('click', this.downloadQr);
  }

  downloadQr(): void {
    let src = document.querySelectorAll('#qr img')[0].getAttribute('src');
    var a = document.createElement('a');
    a.href = String(src);
    a.download = 'QR.png';
    a.click();
  }

  getbuildShared(red: string): string {
    switch (red) {
      case 'facebook':
        return Shared.FACEBOOK + document.location.href;
        break;
      case 'whatssapp':
        return Shared.WHATSAPP + document.location.href;
        break;
      case 'twitter':
        return Shared.TWITTER + document.location.href;
        break;
      case 'sms':
        return Shared.SMS + document.location.href;
        break;
      case 'phone':
        return (
          Shared.PHONE +
          this.publicCardData.claveTelefono +
          this.publicCardData.telefono
        );
        break;
      case 'maps':
        return Shared.MAPS + this.publicCardData.domicilio;
        break;
      default:
        return '';
        break;
    }
  }

  showSuccess(): void {
    this.toastr.success('Copiado al portapapeles.', 'Copiado!');
  }

  async buildVCard(): Promise<void> {
    const image: any = await getImageBase64FromUrl(
      DocumentsServe.COVERPHOTOS +
        this.publicCardData.idTarjeta +
        '/' +
        this.publicCardData.urlFotoPerfil
    );
    const image64 = image.split(',');
    const vCardComplete = vCard(image64[1], this.publicCardData, this.urlQR);
    downloadVCard(this.publicCardData.nombre, vCardComplete);
  }

  openContact(): void {
    if (!this.publicCardData.idUsuario) {
      return;
    }
    this.contact.open(this.publicCardData.idUsuario);
  }

  private validateSession(): boolean {
    let session = false;
    if (
      this.encrypt.getSession() !== '' &&
      typeof this.encrypt.getSession().idUsuario === 'number'
    ) {
      session = true;
    }
    var diff = Math.abs(
      new Date(this.encrypt.getSession().FechaInicio).getTime() -
        new Date().getTime()
    );
    var minutes = Math.floor(diff / 1000 / 60 / 60);
    if (minutes > 23) {
      session = false;
    }
    return session;
  }

  goToCenter(): void {
    const position = (window.innerWidth * TabSize.SIZE) / 100;
    this.statusScroll.emit(position);
    this.currentTab = PageTab.ABOUTME;
    this.currentTabChange.emit(PageTab.PRESENTATION);
  }
}
